/*
    Grab the language from I18n.locale
    and returns the correct language code supported by Seismic
    see https://seismic.atlassian.net/wiki/spaces/UNIFY/pages/3220835555/Lessonly+Seismic+Language+Comparison#Unioned-Set
    for the list of supported languages
  */

const localeRegionMap = {
  es: 'es-ES',
  fr: 'fr-FR',
  de: 'de-DE',
  pt: 'pt-BR',
  it: 'it-IT',
  nl: 'nl-NL',
  ru: 'ru-RU',
  tr: 'tr-CY',
  'zh-CN': 'zh-CN',
  ja: 'ja-JP',
  en: 'en-US',
};

const languageMapper = () => {
  return localeRegionMap[I18n.locale] || 'en-US';
};

export default languageMapper;
